import {styledByTheme} from '../../../../themes/architecture/styled-by-theme';
import {ListTitleDefaultBox} from './list-title.default.box';
import {ListTitleCasino777Box} from './list-title.casino777.box';
import {ListTitleCipBox} from './list-title.cip.box';
import {ListTitleCisBox} from "./list-title.cis.box";

export const ListTitleBox = styledByTheme(ListTitleDefaultBox)
    .forCasino777(ListTitleCasino777Box)
    .forCip(ListTitleCipBox)
    .forWsopCip(ListTitleCipBox)
    .forCis(ListTitleCisBox)
    .apply();